import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismMetricBlock } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { t } from 'ember-intl';
import type { FormattedOffset } from 'lumen/models/channel-pricing-subscription-config';

import styles from './channel-offset-tooltip.module.css';

interface HotelChannelPricingTooltipsChannelOffsetTooltipSignature {
  Args: {
    label: string;
    offset?: FormattedOffset;
  };
}

export default class HotelChannelPricingTooltipsChannelOffsetTooltip extends Component<HotelChannelPricingTooltipsChannelOffsetTooltipSignature> {
  @service declare intl: Services['intl'];

  get offset(): string {
    return this.args.offset?.value ?? this.intl.t('general.missing');
  }

  <template>
    <EmberTooltip @side="right" @tooltipClass="base-tooltip {{styles.tooltip}}">
      <div class="{{styles.header}} flex items-center justify-start p-400">
        <h4>
          {{@label}}
        </h4>
      </div>
      <PrismMetricBlock>
        <:value>
          <div class="flex items-center gap-50">
            <p>{{this.offset}}</p>
          </div>
        </:value>
        <:label>
          {{t "general.offset"}}
        </:label>
      </PrismMetricBlock>
    </EmberTooltip>
  </template>
}
